/* global $, I18N */

import { Controller } from 'stimulus';
import hasHistorySupport from '../helpers/hasHistorySupport';
import debounce from '../helpers/debounce';
import createEvent from '../helpers/createEvent';

class Filter extends Controller {
  connect() {
    this.filterDebounced = debounce(this.filter.bind(this), 150);

    this.onFilterChange();
  }

  onFilterChange() {
    this.filterDebounced();

    const priceField = this.element.querySelector('[name="price_from"]');

    if (priceField) {
      createEvent(priceField, 'update');
    }
  }

  filter() {
    this.emptyResults();
    this.toggleSpinner(true);

    let parameters = $(this.formTarget).serialize();
    const canonical = document.querySelector('link[rel="canonical"]').href;

    parameters += `&sort=${this.sortTarget.value}`;

    if (hasHistorySupport()) {
      const url = `${canonical}${parameters ? '?' : ''}${parameters}`;
      try {
        window.history.replaceState(null, null, url);
      } catch (error) {
        //
      }
    }

    $.get(`${this.getApiUrl()}?${parameters}`)
      .then((res) => {
        this.toggleSpinner(false);
        this.resultsTarget.innerHTML = res.products;
        this.resultsCountTargets.forEach((target) => {
          target.innerHTML = `${res.count} ${res.count === 1 ? I18N.result : I18N.results}`;
          target.style.display = 'inline-block';
        });
      }).then(() => {
        $('[data-toggle="tooltip"]').tooltip({
          trigger: 'click hover focus',
        });

        $('[data-toggle="popover"]').popover({
          trigger: 'click hover focus',
        });
      });
  }

  emptyResults() {
    this.resultsTarget.innerHTML = '';
  }

  toggleSpinner(state) {
    this.spinnerTarget.style.display = state ? 'block' : 'none';
  }

  getApiUrl() {
    return this.formTarget.action;
  }
}

Filter.targets = [
  'form',
  'sort',
  'spinner',
  'results',
  'resultsCount',
];

export default Filter;
